module.exports = __webpack_public_path__ + "static/media/twitter.a74d4cf6.svg";